module.exports = reactLifecyclesCompat;